// import React from "react";
// import { CloudPlusContent } from "../Components/CloudPlusContent";

// const CloudPlus = () => {
//   return <CloudPlusContent />;
// };

// export default CloudPlus;
import React from "react";
import { getSEOData } from "../../../../global/utils/constants/seoConfig";
import SEO from "../../../../global/components/SEO/SEO";
import { CloudPlusContent } from "../Components/CloudPlusContent";

const CloudPlus = () => {
  const seoData = getSEOData("/cloud-plus");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <CloudPlusContent />
    </>
  );
};

export default CloudPlus;